import type {
    DataGridEntityDisplay,
    DataGridStatusDisplay,
    DataGridStatusMap,
} from "../cells/cellValueTypes";
import type { DataGridSkeletonPreset } from "../states/skeletonTypes";

const AVATAR_SKELETONS: Record<DataGridEntityDisplay, DataGridSkeletonPreset> =
    { avatar: "avatar", avatarAndName: "avatarText" };

/** An entity or workspace column's display, `avatarAndName` by default, and its placeholder. */
export const toAvatarDisplay = (
    display: DataGridEntityDisplay = "avatarAndName",
) => ({ display, skeleton: AVATAR_SKELETONS[display] });

const STATUS_SKELETONS: Record<
    DataGridStatusDisplay["variant"],
    DataGridSkeletonPreset
> = {
    tag: "tag",
    indicator: "indicator",
    icon: "statusIcon",
};

/**
 * A status column's placeholder: the display most of its statuses use (the
 * first on a tie), or text when none is mapped, as unmapped values show.
 */
export const toStatusSkeleton = (
    statuses: DataGridStatusMap | undefined,
): DataGridSkeletonPreset => {
    const counts = new Map<DataGridSkeletonPreset, number>();
    for (const display of Object.values(statuses ?? {})) {
        const skeleton = STATUS_SKELETONS[display.variant];
        counts.set(skeleton, (counts.get(skeleton) ?? 0) + 1);
    }
    let mostUsed: DataGridSkeletonPreset = "text";
    let mostUsedCount = 0;
    counts.forEach((count, skeleton) => {
        if (count > mostUsedCount) {
            mostUsed = skeleton;
            mostUsedCount = count;
        }
    });
    return mostUsed;
};
